import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SUB_COMPANY_LICENSED_STATES_ACTION_TYPE } from '../actions';

const initialState = {};

const subCompanyLicensedStatesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.GET_STATES:
        return payload || initialState;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.ADD_STATE:
      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.EDIT_STATE:
        draft[payload.id] = payload;
        break;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.DELETE_STATE:
        delete draft[meta.licenseId];
        break;

      case SUB_COMPANY_LICENSED_STATES_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default subCompanyLicensedStatesReducer;
